export default __webpack_public_path__ + "static/media/waiting-contract.9ef0184f.png";